import { render, staticRenderFns } from "./NewDuplicate.vue?vue&type=template&id=59a32fbd"
import script from "./NewDuplicate.vue?vue&type=script&lang=ts"
export * from "./NewDuplicate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports